import styled from "styled-components/macro";

export const Container = styled.div`
  padding: auto;
  padding-top: 7em;
  margin: auto;
  width: 75%;
  text-align: center;
  color: var(--grey-0);

  p {
    margin-bottom: 2em;
  }

  h1 {
    text-align: center;
    margin: auto auto 1em auto;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    svg {
      width: 50px;
      margin-right: 10px;
    }
  }
`;
